import { gql } from '@apollo/client';

export const ARCHIVE_OFFER_POST_TEMPLATE = gql`
  mutation ($data: [String!]!) {
    archiveOfferPostTemplates(ids: $data)
  }
`;
